<template>
  <div class="card">
    <div
      class="packshot"
    >
      <div :class="['packshot__pic', 'packshot__pic--revers', product.revers]" />
      <div :class="['packshot__pic', 'packshot__pic--face', product.face]" />
    </div>

    <ProductInjectedContent
      class="content"
      :product="product"
    />
  </div>
</template>

<script>
import ProductInjectedContent from '@/components/products/ProductInjectedContent.vue';

export default {
  components: {
    ProductInjectedContent,
  },

  props: {
    product: { type: Object, required: true },
  },
};
</script>

<style lang="stylus" scoped>
.packshot {
  position: relative;
  height: 155px;
  margin-bottom: 20px;

  +desktop() { display: none; }

  &__pic {
    position: absolute;

    width: 155px;
    background-size: 100%;
  }

  &__pic--face {
    left: 50%;
    transform: translateX(-10px);
  }

  &__pic--revers {
    right: 50%;
    transform: translateX(10px);
  }
}
</style>
